<template>
    <div class="loginWrap_form">
        <div class="loginWrap_form_top">
            <div class="loginWrap_hidden_logo">
                <a :href="$page.props.home_url ?? '/'">
                    <IconLogo />
                </a>
            </div>

            <h1>Creating Organization!</h1>
            <p class="status-message">{{ message }}</p>
            <div class="spinner-container">
                <!--suppress HtmlUnknownAnchorTarget -->
                <SpinnerCircle size="75px" background="#40acff" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import MainLayout from '@/layouts/MainLayout.vue';
import SideLayout from '@/layouts/SideLayout.vue';

export default {
    layout: [MainLayout, SideLayout],
};
</script>

<script setup lang="ts">
import IconLogo from '@/components/icons/IconLogo.vue';
import SpinnerCircle from "@/components/SpinnerCircle.vue";
import { router } from '@inertiajs/vue2';
import { useIntervalFn, useTimeoutPoll } from '@vueuse/core';
import { computed, ref } from 'vue';
import axios from "axios";
import route from 'ziggy-js';

// Message list
const messageIndex = ref<number>(0);
const messageList = ref<string[]>([
    "Hold on tight, we're launching your account into cyberspace!",
    "Don't worry, our virtual hamsters are hard at work setting up your account.",
    "Pour yourself a cup of coffee while we work our magic.",
    "Account creation in progress. Grab some popcorn and enjoy the show!",
    "We're painting your account with digital glitter. It's going to be fabulous!",
    "The squirrels are running on their wheels to power up your account. Hang in there!",
    "Did you know that our servers enjoy a good joke? They're laughing as they create your account.",
    "Our robots are doing the robot dance to celebrate your account's birth.",
    "This is the part where we summon digital unicorns to make your account extra special.",
]);
const message = computed<string>(() => messageList.value[messageIndex.value]);

useIntervalFn(() => {
    if (messageIndex.value < messageList.value.length - 1) {
        messageIndex.value++;
    } else {
        messageIndex.value = 0;
    }
}, 5000);

// Organization status
async function fetchOrganizationStatus() {
    try {
        const response = await axios.get(route('api.v2.organization.status'));

        if (response.data.status === 3) {
            if (isActive.value) {
                pause();
            }

            router.reload();
        }
    } catch (error) {
        console.error(error);
    }

    if (! isActive.value) {
        resume();
    }
}

const { isActive, pause, resume } = useTimeoutPoll(fetchOrganizationStatus, 5000, { immediate: true })
</script>

<style lang="scss" scoped>
.spinner-container {
    padding-top: 20px;
}

.status-message {
    color: #444;
    padding: 5px
}
</style>

